<script setup lang="ts">
defineProps<{ size?: number; label?: string }>();
</script>

<template>
  <svg
    class="animate-spin"
    :width="size ?? 16"
    :height="size ?? 16"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    role="img"
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="3" opacity="0.25" />
    <path
      d="M21 12a9 9 0 0 0-9-9"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
  <span v-if="label" class="sr-only">{{ label }}</span>
</template>
